import React from 'react'
import { useTranslation } from 'react-i18next'

import TextButton from 'components/Luxkit/Button/TextButton'
import useBedbankSelectDates from 'hooks/OfferPage/useBedbankSelectDates'

function BedbankSelectDates() {
  const { t } = useTranslation('offerPage')

  const onCalendarOpenSelectDates = useBedbankSelectDates()

  return (<TextButton
    kind="primary"
    onClick={onCalendarOpenSelectDates}
    data-testid="select-your-dates-button"
    fit="full-width"
  >
    {t('Select your dates', { ns: 'offerPage' })}
  </TextButton>)
}

export default BedbankSelectDates
